const C = require("../constants");

const paymentDialog = is_open => {
    return {
        type: C.PAYMENT_DIALOG,
        is_open
    }
};

export {paymentDialog};


// WEBPACK FOOTER //
// ./src/actions/PaymentDialogActions.js